




































import { Component, Vue } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import SectionWrapper from '@/componentsV2/molecules/SectionWrapper/SectionWrapper.vue';
import PerformanceCustomerDetailActivities from '@/componentsV2/templates/PerformanceCustomerDetailActivities/PerformanceCustomerDetailActivities.vue';
import ItemListDetail from './History/ItemListDetail.vue';
import OverviewTransaction from './Overview/Overview.vue';
import PerformanceCustomerCenterService from '@/api/PerformanceCustomerCenterService';

import { IPerformanceTransactionDetailData } from '@/models/performance';

@Component<TransactionItemDetailPortal>({
  components: {
    Page,
    SectionWrapper,
    PerformanceCustomerDetailActivities,
    ItemListDetail,
    OverviewTransaction
  }
})
export default class TransactionItemDetailPortal extends Vue {
  service: PerformanceCustomerCenterService = new PerformanceCustomerCenterService();
  connectTransactionId = '';

  detailTransaction?: IPerformanceTransactionDetailData | null = null;

  breadcrumbs = [
    {
      label: 'Loyalty Coins',
      path: '/performance/transactions-center'
    },
    {
      label: 'Transaction Status'
    }
  ];

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  goBack() {
    this.$router.back();
  }

  created() {
    const connectTransactionId = this.$route.params.connectTransactionId;

    if (connectTransactionId) {
      this.connectTransactionId = connectTransactionId;
      this.loadDetailTransaction({ updateListTransaction: false });
    }
  }

  isLastItem(index: number) {
    if (!this.detailTransaction) {
      return false;
    }
    return index + 1 === this.detailTransaction.history.length;
  }

  async loadDetailTransaction({
    updateListTransaction
  }: {
    updateListTransaction: boolean;
  }) {
    const { data } = await this.service.detailTransaction(
      this.connectTransactionId
    );

    if (updateListTransaction) {
      this.$store.dispatch('performance/UPDATE_TRANSACTION_LOYALTY_MODULE', {
        context: 'transactionsCenter',
        dataToUpdate: data.transaction
      });
    }

    this.detailTransaction = data;
  }
}
